import React from 'react';
import proptypes from 'prop-types';
const { number, bool } = proptypes;
import { Skeleton, SkeletonContent, SkeletonLine, SkeletonBlock } from '@one-thd/sui-atomic-components';

export const ListViewPlaceHolder = ({ count, isMobile }) => {
  const placeholders = new Array(Math.max(1, count)).fill('');
  return (
    <>
      {placeholders.map((placeholder, placeholderIndex) => {
        return (
          <div key={placeholderIndex} data-testid="list-item-placeholder" className="sui-py-1 sui-w-full">
            {isMobile && (
              <Skeleton
                disablePadding="x"
                orientation="horizontal"
                PaperProps={{
                  className: 'sui-w-full sui-border-b-1 sui-border-solid sui-border-primary',
                  variant: 'shadow'
                }}
              >
                <div className="sui-flex sui-flex-col sui-gap-2 sui-p-2">
                  {/* Actions row placeholder (right-aligned) */}
                  <div className="sui-flex sui-justify-end">
                    <div className="sui-w-24">
                      <SkeletonLine numberOfLines={1} />
                    </div>
                  </div>

                  {/* Image + Details (3-column grid) */}
                  <div className="sui-grid sui-grid-cols-3 sui-gap-2">
                    {/* Left column - Image (1/3) */}
                    <div className="sui-col-span-1">
                      <SkeletonBlock aspect="wide" />
                    </div>

                    {/* Right column - Details (2/3) */}
                    <div className="sui-col-span-2 sui-flex sui-flex-col sui-gap-1">
                      <SkeletonLine numberOfLines={5} />
                      {/* Fulfillment row */}
                      <div className="sui-grid sui-grid-cols-2 sui-gap-2">
                        <SkeletonLine numberOfLines={1} />
                        <SkeletonLine numberOfLines={1} />
                      </div>
                    </div>
                  </div>

                  {/* Price/Cart section (2 columns) */}
                  <div className="sui-grid sui-grid-cols-2 sui-gap-2">
                    <div>
                      <SkeletonLine numberOfLines={2} />
                    </div>
                    <div>
                      <SkeletonLine numberOfLines={3} />
                    </div>
                  </div>
                </div>
              </Skeleton>
            )}
            {!isMobile && (
              <Skeleton
                orientation="horizontal"
                PaperProps={{
                  className: 'sui-w-full sui-border-b-1 sui-border-solid sui-border-primary',
                  variant: 'shadow'
                }}
              >
                <div className="sui-grid sui-grid-cols-12 sui-gap-2 sui-p-2">
                  {/* Section 1: Image - col-span-1 */}
                  <div className="sui-col-span-1">
                    <SkeletonBlock aspect="square" />
                  </div>

                  {/* Section 2: Product Details - col-span-3 */}
                  <div className="sui-col-span-3">
                    <SkeletonLine numberOfLines={5} />
                  </div>

                  {/* Section 3: Inventory - col-span-2 */}
                  <div className="sui-col-span-2">
                    <SkeletonLine numberOfLines={2} />
                  </div>

                  {/* Section 4: Price + Rating - col-span-2 */}
                  <div className="sui-col-span-2">
                    <SkeletonLine numberOfLines={2} />
                  </div>

                  {/* Section 5: Quantity + Cart - col-span-2 */}
                  <div className="sui-col-span-2">
                    <SkeletonLine numberOfLines={3} />
                  </div>

                  {/* Section 6: Actions - col-span-2 */}
                  <div className="sui-col-span-2">
                    <SkeletonLine numberOfLines={2} />
                  </div>
                </div>
              </Skeleton>
            )}
          </div>
        );
      })}
    </>
  );
};

ListViewPlaceHolder.displayName = 'ListViewPlaceHolder';

ListViewPlaceHolder.propTypes = {
  count: number,
  isMobile: bool
};

ListViewPlaceHolder.defaultProps = {
  count: 24,
  isMobile: false
};
